import { attr, belongsTo, hasMany } from '@warp-drive/legacy/model';

import Model from 'umg-ember-backend/models/variant-model';
import {
  buildValidations,
  disabledWhenVariant,
  validator,
} from 'umg-ember-backend/utils/validations';

const Validations = buildValidations({
  channel: [
    validator('belongs-to'),
    validator('presence', {
      presence: true,
      disabled: disabledWhenVariant(),
    }),
  ],
  division: [
    validator('belongs-to'),
    validator('presence', {
      presence: true,
      disabled: disabledWhenVariant(),
    }),
  ],
  headline: validator('presence', true),
  text: validator('presence', true),
  jobFunctions: [
    validator('has-many'),
    validator('presence', {
      presence: true,
    }),
  ],
});

export const settings = {
  variantProperties: [
    'cmsLanguageId',
    'seoTitle',
    'seoDescription',
    'keywords',
    'seoImage',
    'cmsState',
    'headline',
    'subHeadline',
    'text',
  ],
};

export default class JobModel extends Model.extend(Validations) {
  @attr('array') employmentType;
  @attr('string') headline;
  @attr('number', { defaultValue: 0 }) priority;
  @attr('string') subHeadline;
  @attr('string') text;

  // CMS fields
  @attr cmsKilldate;
  @attr cmsLivedate;
  @attr('string') seoTitle;
  @attr('string') seoDescription;
  @attr('string') keywords;
  @attr('number', { defaultValue: 2 }) cmsState;

  // Meta fields
  @attr cmsCreated;
  @attr cmsDeleted;
  @attr cmsLocktime;
  @attr cmsModified;
  @attr() cmsHistory;
  @belongsTo('user', { async: true, inverse: null }) cmsOwnerId;
  @belongsTo('user', { async: true, inverse: null }) cmsCreatorId;
  @belongsTo('user', { async: true, inverse: null }) cmsLockerId;
  @belongsTo('user', { async: true, inverse: null }) cmsModifierId;

  // Relations
  @belongsTo('asset', { async: true, inverse: null }) asset;
  @belongsTo('asset', { async: true, inverse: null }) seoImage;
  @belongsTo('category', { async: true, inverse: null }) category;
  @belongsTo('channel', { async: true, inverse: null }) channel;
  @hasMany('category', { async: true, inverse: null }) jobFunctions;
  @belongsTo('division', { async: true, inverse: null }) division;
  @belongsTo('label', { async: true, inverse: null }) label;
  @belongsTo('link', { async: true, inverse: null }) link;
  @belongsTo('location', { async: true, inverse: null }) location;
  @hasMany('taxon', { async: true, inverse: null }) taxa;

  // Getter and setter
  get displayHeadline() {
    return this.headline;
  }

  get displayLabel() {
    return this.headline;
  }
}
